export const Bannersdata={
    "list":[
          {"id":1,"image":"http://47.108.153.30:7878/images/bannerOne.jpg","width": 750,"link":"/home"},
          {"id":2,"image":"http://47.108.153.30:7878/images/bannerTwo.jpeg","width": 750,"link":"/home"},
          {"id":3,"image":"http://47.108.153.30:7878/images/bannerThree.jpeg","width": 750,"link":"/home"}, 
          {"id":4,"image":"http://47.108.153.30:7878/images/bannerFour.jpeg","width": 750,"link":"/home"},
          {"id":5,"image":"http://47.108.153.30:7878/images/bannerFive.jpeg","width": 750,"link":"/home"},
          {"id":6,"image":"http://47.108.153.30:7878/images/bannerSix.jpeg","width": 750,"link":"/home"},
          {"id":7,"image":"http://47.108.153.30:7878/images/bannerSeven.jpeg","width": 750,"link":"/home"},
          {"id":8,"image":"http://47.108.153.30:7878/images/bannerEight.jpeg","width": 750,"link":"/home"}
    ]
}
